import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en/translation.json";
import es from "./locales/es/translation.json";
import fr from "./locales/fr/translation.json";
import id from "./locales/id/translation.json";
import tpi from "./locales/tpi/translation.json";
import pt from "./locales/pt/translation.json";
import fil from "./locales/fil/translation.json";
import ar from "./locales/ar/translation.json";

const allTranslations = {
  en: { translation: en },
  es: { translation: es },
  fr: { translation: fr },
  ar: { translation: ar },
  pt: { translation: pt },
  tpi: { translation: tpi },
  id: { translation: id },
  fil: { translation: fil },
};
const languagesFromStorage = localStorage.getItem("language")?.split(",") || [];
const defaultLanguageFromStorage = localStorage.getItem("is_language") || "";
const languages = languagesFromStorage
  .map((lang) => lang.trim())
  .filter((lang) => lang && allTranslations[lang]);
const defaultLanguage = defaultLanguageFromStorage.trim();
let initialLanguage = "en";
if (languages.length > 0) {
  if (defaultLanguage && languages.includes(defaultLanguage)) {
    initialLanguage = defaultLanguage;
  } else if (languages.length > 0) {
    initialLanguage = languages[0];
  }
} else if (defaultLanguage && allTranslations[defaultLanguage]) {
  initialLanguage = defaultLanguage;
} else {
  initialLanguage = "en";
}
i18n.use(initReactI18next).init({
  resources: allTranslations,
  lng: initialLanguage,
  fallbackLng: "en",
  interpolation: { escapeValue: false },
  detection: {
    order: ["localStorage", "navigator"],
    caches: ["localStorage"],
  },
  load: "languageOnly",
  preload: Object.keys(allTranslations),
});
const handleStorageChange = (e) => {
  if (e.key === "is_language" || e.type === "cStorage") {
    const newDefaultLanguage = localStorage.getItem("is_language");
    if (newDefaultLanguage && newDefaultLanguage !== i18n.language) {
      i18n.changeLanguage(newDefaultLanguage);
    }
  }
};
window.addEventListener("storage", handleStorageChange);
window.addEventListener("cStorage", handleStorageChange);

export default i18n;
